module.exports = __webpack_public_path__ + "static/artworking-2531877f89f1a343fbaa0e75b768689c.jpg";